import type { CanvasStoreContext } from '../types';
import { coreEntityCommands, type CoreEntityCommand } from './coreCommands';
import { canvasCommands, type CanvasMetaCommand } from './canvasCommands';
import { layerCommands, type LayerCommand } from './layerCommands';
import { connectorCommands, type ConnectorCommand } from '../entities/connector/commands';
import { groupCommands, type GroupCommand } from '../entities/group/commands';
import { taskCommands, type TaskCommand } from '../entities/task/commands';
import { textblockCommands, type TextblockCommand } from '../entities/textblock/commands';
import { textlabelCommands, type TextlabelCommand } from '../entities/textlabel/commands';
import { spriteCommands, type SpriteCommand } from '../entities/sprite/commands';
import { imageCommands, type ImageCommand } from '../entities/image/commands';
import { blocknodeCommands, type BlocknodeCommand } from '../entities/blocknode/commands';
import { shapeCommands, type ShapeCommand } from '../entities/shape/commands';
import { adrTriggerCommands, type AdrTriggerCommand } from '../entities/adrTrigger/commands';

export const commandRegistry = {
  ...coreEntityCommands,
  ...canvasCommands,
  ...layerCommands,
  ...connectorCommands,
  ...groupCommands,
  ...taskCommands,
  ...textblockCommands,
  ...textlabelCommands,
  ...spriteCommands,
  ...imageCommands,
  ...blocknodeCommands,
  ...shapeCommands,
  ...adrTriggerCommands,
} as const;

/** The full typed command union. Agents, UI, and all dispatch calls use this. */
export type CanvasCommand =
  | CoreEntityCommand
  | CanvasMetaCommand
  | LayerCommand
  | ConnectorCommand
  | GroupCommand
  | TaskCommand
  | TextblockCommand
  | TextlabelCommand
  | SpriteCommand
  | ImageCommand
  | BlocknodeCommand
  | ShapeCommand
  | AdrTriggerCommand;

/** Execute a command against a context. Pure function. */
export function executeCommand(ctx: CanvasStoreContext, command: CanvasCommand): CanvasStoreContext {
  const handler = (commandRegistry as Record<string, (ctx: CanvasStoreContext, ev: any) => CanvasStoreContext>)[command.type];
  if (!handler) throw new Error(`Unknown command type: ${command.type}`);
  return handler(ctx, command);
}
